<form #form="ngForm" (ngSubmit)="form.valid && submit()" *ngIf="widgetSettings.enabled; else noSubscription">
  <div class="input-c">
    <lib-smarty-address-auto-complete
      [(ngModel)]="address"
      name="felloAddress"
      id="felloPropertyAddress"
      [disabled]="isLoading"
      #propertyAddress="ngModel"
      [placeholder]="widgetSettings.settings?.searchWidget?.textBox?.placeholder ?? ''"
      maxlength="100"
      [required]="true"
      (optionSelected)="submit()"
    ></lib-smarty-address-auto-complete>
    <button type="submit">
      <ngx-spinner
        [name]="spinnerName"
        type="ball-pulse"
        bdColor="transparent"
        size="small"
        color="inherit"
        [fullScreen]="false"
      ></ngx-spinner>
      <span
        class="text"
        [style.color]="widgetSettings.theme.button.textColor"
        [innerHTML]="widgetSettings.settings?.searchWidget?.searchButton?.text?.content"
        [ngClass]="{'opacity-0': isLoading}"
      ></span>
    </button>
  </div>
</form>

<ng-template #noSubscription>
  <div class="p-4" *ngIf="widgetSettings?.signature; let signature">
    <p class="text-size-18 fw-600">Please contact your Agent,</p>
    <lib-agent-signature [agentSignature]="signature"></lib-agent-signature>
  </div>
</ng-template>
